export const siteLogos: { [key: string] : {name: string, logo: string}} = {
  'fd': {
    name: "FanDuel",
    logo: `${process.env.PUBLIC_URL}/images/FD.png`
  },
  'dk': {
    name: "DraftKings",
    logo: `${process.env.PUBLIC_URL}/images/DK.png`
  },
  'yh': {
    name: "Yahoo",
    logo: `${process.env.PUBLIC_URL}/images/yahoo.png`
  },
}

export const sportLogos: { [key: string] : {name: string, logo: string, invertBackground: boolean}} = {
  'NFL': {
    name: "NFL",
    logo: `${process.env.PUBLIC_URL}/images/NFL.png`,
    invertBackground: false,
  },
  'MLB': {
    name: "MLB",
    logo: `${process.env.PUBLIC_URL}/images/MLB.png`,
    invertBackground: false,

  },
  'PGA': {
    name: "PGA",
    logo: `${process.env.PUBLIC_URL}/images/PGA.png`,
    invertBackground: false,

  },
  'NBA': {
    name: "NBA",
    logo: `${process.env.PUBLIC_URL}/images/NBA.png`,
    invertBackground: false,
  },
  'MMA': {
    name: "MMA",
    logo: `${process.env.PUBLIC_URL}/images/UFC.png`,
    invertBackground: false,
  },
  'NASCAR': {
    name: "NASCAR",
    logo: `${process.env.PUBLIC_URL}/images/NASCAR.png`,
    invertBackground: false,
  },
  'CFB': {
    name: "CFB",
    logo: `${process.env.PUBLIC_URL}/images/CFB.png`,
    invertBackground: false,
  },
  'NHL': {
    name: "NHL",
    logo: 'https://awesemostorage.blob.core.windows.net/sports/nhl/nhl.png',
    invertBackground: false,
  },
}